// Stub for the `web-vitals` package.
//
// `@amplitude/analytics-browser` pulls in `@amplitude/plugin-web-vitals-browser`,
// which hard-pins `web-vitals@6.2.1` (no semver range). That version ships
// class-field syntax this project's Babel/webpack setup can't parse, which
// broke the production build entirely (see PR history for the incident).
//
// We don't want/need that plugin's data anyway (`amplitude.init` is called
// with `defaultTracking: false` in src/config/amplitude.js, specifically to
// avoid any automatic data collection beyond the one manual trackEvent call
// this app makes), so this stub is aliased in place of the real package
// (see .rescriptsrc.js) instead of patching Babel or downgrading a version
// Amplitude pins on purpose. Each export matches web-vitals' on*() signature
// but never invokes the callback, which is a no-op functionally equivalent
// to "no web vitals reporting", a harmless outcome either way.
// eslint-disable-next-line no-empty-function
const noop = () => {};

export const onCLS = noop;
export const onFCP = noop;
export const onINP = noop;
export const onLCP = noop;
export const onTTFB = noop;
